"use client";
import { jsx, jsxs } from 'react/jsx-runtime';
import { includes } from 'lodash';
import { useState } from 'react';
import { Spinner } from './Spinner2.js';
import styles from './Buttons4.js';

const BaseButton = ({ variant = 'primary', disabled = false, state, onClick, layoutClassName, type, isLoading: isLoadingProp = false, showOutline = false, size = 'medium', children, icon: Icon, iconEnd: IconEnd, iconStart: IconStart, htmlFor, textWidth, }) => {
    const [isAsyncLoading, setIsAsyncLoading] = useState(false);
    const isIcon = variant === 'iconPrimary' || variant === 'iconSecondary' || variant === 'iconText';
    const spinnerSizes = size === 'large' ? 20 : 16;
    const isLoading = isLoadingProp || isAsyncLoading;
    const socialIconClassname = variant === 'social' ? 'h-6 w-6' : '';
    const onClickCall = async () => {
        try {
            setIsAsyncLoading(true);
            if (onClick)
                await onClick();
            setIsAsyncLoading(false);
        }
        catch (_a) {
            setIsAsyncLoading(false);
        }
    };
    return (jsx("button", { className: styles.button(layoutClassName, variant, disabled, showOutline, size, state, isLoading), disabled: disabled, onClick: !isLoading && !disabled ? onClickCall : undefined, type: type, role: "button", children: jsxs("label", { htmlFor: htmlFor, className: styles.container, children: [isLoading && (jsx("div", { className: styles.spinnerStyle, children: jsx(Spinner, { borderWidth: 2, size: spinnerSizes, state: state, variant: includes(['primary', 'iconPrimary'], variant) ? 'secondary' : 'primary' }) })), jsxs("div", { className: styles.childrenContainer(!!children, isLoading, isIcon, variant), children: [isIcon && Icon && jsx(Icon, { className: socialIconClassname }), !isIcon && !Icon && IconStart && jsx(IconStart, { className: socialIconClassname }), !isIcon && jsx("div", { className: `${textWidth} text-start`, children: children }), !isIcon && !Icon && IconEnd && jsx(IconEnd, { className: socialIconClassname })] })] }) }));
};

export { BaseButton as default };
